import { FlinkMark, IconArrow, UE_LOGO_SRC, APPLY_ANCHOR } from './UEShared';

const UENav = () => (
  <nav>
    <div className="nav-inner">
      <a href="/" className="nav-logos" aria-label="Flink × Uber Eats">
        <FlinkMark className="nav-flink-mark" />
        <span className="nav-x">×</span>
        <img className="nav-ue" src={UE_LOGO_SRC} alt="Uber Eats" />
      </a>
      <ul className="nav-links">
        <li>
          <a href="#why">What you get</a>
        </li>
        <li>
          <a href="#process">How it works</a>
        </li>
        <li>
          <a href="#compensation">Pay</a>
        </li>
        <li>
          <a href="#faq">FAQs</a>
        </li>
      </ul>
      <a href={APPLY_ANCHOR} className="nav-cta">
        Apply now
        <IconArrow />
      </a>
    </div>
  </nav>
);

export default UENav;
